'use strict';

goog.provide("Ntry.AiResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.AiResult = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryResultContainer');
        var title = Ntry.createElement('div', container, null, 'ntryResultTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = '닫기';

        var content = Ntry.createElement('div', container, null, 'ntryResultContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryResultLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryResultRightDiv');
        this._successContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');

        this._usedBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._usedBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._usedBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._certDiv = Ntry.createElement('div', this._successContent, null, 'ntryResultCertDiv_ai', 'ntryRemove');

        this._certDivLeft = Ntry.createElement('div', this._certDiv, null, 'ntryResultCertDivLeft');

        this._certNameLabel = Ntry.createElement('span', this._certDivLeft, null, 'ntryResultContentNameLabel');
        this._certNameLabel.innerHTML = Lang.Menus.jr_whats_ur_name;

        this._certNameInput = Ntry.createElement('input', this._certDivLeft, null, 'ntryResultContentNameInput_ai');
        this._certNameInput.type = "text";

        this._certLink = Ntry.createElement('div', this._certDiv, null, 'ntryResultContentCert');
        this._certLink.innerHTML = Lang.Menus.jr_down_cert;

        this._failContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = Ntry.createElement('span', this._failContent, null, 'ntryResultFailCauseSpan');

        this._essentialBlocks = Ntry.createElement('div',this._failContent, null, 'ntryAiResultEssentialBlocks');

        this._replayButton = Ntry.createElement('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = Lang.Menus.replay;

        this._nextButton = Ntry.createElement('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = Lang.Menus.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.goToUrl(that._nextLink);
        });
    };

    p.update = function() {
    };

    p.randomString = function(len) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
        Ntry.addEventListener("showCert", this, this.showCert);
    };

    p.showCert = function(mode) {
        this._usedBlockCnt.ntryRemove();
        this._failContent.ntryRemove();
        this._replayButton.ntryRemove();
        this._certDiv.ntryShow();
        this._nextButton.ntryRemove();
        this._successContent.ntryShow();
        $(this._certDiv).show();
        $(this._successContent).css('margin-top', '20px');

        this._usedBlockPrefix.innerHTML = "";

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');
        this._leftImg.addClass('ntryResultSuccessAi');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
            $(self._certDiv).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Users.name_not_empty);
                self._certNameInput.focus();
            } else if(window.cpartyuserkey) {
                window.location.href = '/codingparty/2015#!/certificate/'+window.cpartyuserkey+'/'+username +'/'+mode;
            }
        });

        $(this._view).css('display', 'block');
    };

    p.initState = function() {
        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");

            $(self._view).css('display', 'none');
        });

        this._nextLink = '/we/ai#!/'+(stageId-20+1);
        if (window.cpartyuserkey)
            this._nextLink = '/codingparty/2015#!/5/'+(stageId-20+1);

        if (!window.aiuserkey) {
            window.aiuserkey = this.randomString(8);
            var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            $.ajax({
                method: "POST",
                url: "/api/ai/user",
                data: {
                    key: window.aiuserkey
                },
                headers: {'csrf-token':csrfToken},
                cache: false
            });
        }

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert('이름을 입력하세요.');
                self._certNameInput.focus();
            } else if(window.cpartyuserkey) {
                window.location.href = '/codingparty/2015#!/certificate/'+window.cpartyuserkey+'/'+username +'/5';
            } else{
                window.location.href = '/we/ai#!/c/c/'+window.aiuserkey+'/'+username
            }
        });

        if (success) {
            var isEssentialUsed = this.inspectEssential();
            if (isEssentialUsed || stageId === 30) {
                this.success(stageId, this.getScrollX());
            } else {
                this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            if (stageId === 30 && this.getScrollX() > 0) {
                this.success(stageId, this.getScrollX());
            } else {
                this.fail(stageId, cause);
            }
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        var essentialBlockInfo = Ntry.configManager.getConfig('essentialBlockInfo')
        if(_.isEmpty(essentialBlockInfo)) return true;

        var restoreScript = Blockly.mainWorkspace.getTopBlocks(Blockly.mainWorkspace);
        if (!restoreScript) return true;

        var blocks = _.filter(restoreScript, function(b){
            var type = b.type;
            var headBlocks = [
                'ai_start',
                'ai_start_un',
                'maze_step_start',
                'maze_step_unstart',
                'maze_define_unfunction',
                'maze_define_function'
            ];

            return headBlocks.indexOf(type) > -1;
        });

        var restoreScript = _.reduce(blocks, function(a,b){
            var txt = Blockly.Xml.domToText(Blockly.Xml.blockToDom_(b));
            return a + txt;
        }, '');

        /* inspect all essentialBlocks pass regex for
         * restore block script
        */
        var matchCnt = 0;
        for (var i=0,len=essentialBlockInfo.blocks.length; i<len; i++) {
            if (new RegExp(essentialBlockInfo.blocks[i], 'i').test(restoreScript))
                matchCnt++;
        };
        return matchCnt >= essentialBlockInfo.matchCnt;
    };
    p.getScrollX = function() {
        if (!this._scroll) {
            var entities = Ntry.entityManager.getEntitiesByComponent(
                Ntry.STATIC.SCROLL
            )
            if (!entities)
                return 0;
            else {
                var scrollEntity;
                for (var key in entities)
                    this._scroll = Ntry.entityManager.getComponent(
                        key, Ntry.STATIC.SCROLL);
            }
        }
        return Math.floor(this._scroll.scrollX/100);
    };

    p.success = function(stageId, scrollX) {
        this._leftImg.addClass('ntryResultSuccessAi');
        this._replayButton.removeClasses();

        if (stageId === 30) {

            if (window.aiuserkey) {
                var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                $.ajax({
                    method: "PUT",
                    url: "/api/ai/user/finish/"+window.aiuserkey,
                    headers: {'csrf-token':csrfToken},
                    cache: false
                });
            }
            if (scrollX >= 95) {
                this._usedBlockCnt.ntryRemove();
                this._usedBlockPrefix.ntryRemove();
                this._usedBlockSuffix.innerHTML = Lang.Menus.ai_success_msg_1;
            } else {
                this._usedBlockCnt.innerHTML = scrollX;
                this._usedBlockPrefix.innerHTML = Lang.Menus.ai_success_msg_2;
                this._usedBlockSuffix.innerHTML = Lang.Menus.ai_success_msg_3;
            }
            this._replayButton.addClass("ntryResultReplayButtonFailed");
            this._certDiv.ntryShow();
            this._nextButton.ntryRemove();
        } else {
            this._usedBlockCnt.innerHTML = Ntry.countUsedBlocks();
            this._usedBlockPrefix.innerHTML = Lang.Menus.ai_success_msg_4;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_using_blocks;
            this._replayButton.addClass('ntryResultReplayButton');
            this._nextButton.ntryShow();
        }

        this._successContent.ntryShow();
        this._failContent.ntryRemove();

        if (window.cpartyuserkey)
            Ntry.dispatchEvent('saveLogs', 'finish');
    };

    p.fail = function(stageId, cause) {
        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.ai_cause_msg_1,
            Lang.Menus.ai_cause_msg_2,
            Lang.Menus.ai_cause_msg_3,
            Lang.Menus.ai_cause_msg_4
        ]

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();
        switch (cause) {
            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[0];
                causeStyle = 1;
                break;

            case Ntry.STATIC.COLLISION:
                causeString = causeMsgs[1];
                causeStyle = 2;
                break;

            case Ntry.STATIC.LOST:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;
            case Ntry.STATIC.ESSENTIAL_REQUIRED:

                causeString = causeMsgs[3];
                causeStyle = 4;
                this.renderBlocks(stageId);
                break;
        }

        var imageClass = 'ntryResultFail_ai_'+ causeStyle;

        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.removeClasses();
        // this._replayButton.addClass("ntryResultReplayButtonFailed");
        this._replayButton.addClass("ntryResultFailAndReply");
    };

    p.renderBlocks = function(stageId) {
        var type = 1;

        if(stageId ==23 )
            type = 1;
        else if(stageId == 24)
            type = 2;
        else if(stageId >= 25 && stageId <= 30)
            type = 3;

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.addClass("ntryAiResultEssentialBlocks");
        this._essentialBlocks.addClass("ntryAiResultEssentialBlocks_" + type);

    }


})(Ntry.AiResult.prototype);
